export default function About({ toContact }) {
  return (
    <main
      className="lg:flex lg:justify-around lg:items-center mx-6 my-10 lg:my-20 lg:mx-16"
      id="home"
    >
      <div>
        <img
          src="./assets/sam.png"
          alt=""
          className="w-[350px] h-[350px] m-auto object-cover rounded-full p-2 bg-[#41f2ff] bg-opacity-25"
        />
      </div>

      <div className="flex flex-col">
        <h1 className="mx-4 mt-10 md:mt-2 p-0">Hi, I'm Samuel</h1>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-semibold text-center">
          A Web3 Frontend Developer
        </h1>
        {/* and{" "}
        <a href="https://behance.net/psalmuel01" className="text-[#41fa]">
          Designer
        </a> */}
        {/* Web3 Frontend Developer & Smart Contract Writer */}
        <p className="sm:text-center mb-5">
          Building Functional Web Pages with <b>Next.js</b> and{" "}
          <b>Typescript</b>
        </p>
        <p className="w-full m-auto leading-loose sm:text-center sm:w-[600px]">
          I build Websites and Web Apps for the purpose of building an online
          space and boosting the growth and performance of my clients.
        </p>
        <a
          href="!#"
          className="my-5 uppercase bg-[#0D0E10] text-white dark:bg-white dark:text-[#0D0E10] py-4 px-8 rounded-full hover:scale-105 trans duration-200 mx-auto w-max h-max"
          onClick={toContact}
        >
          Connect with me
        </a>
        <a
          href="https://docs.google.com/document/d/1WiNIh9tLPGpjOHYcCfbTfKhnU5kkeKqdCw2er4UHEy8/edit?usp=sharing"
          className="hover:underline text-xl text-center"
        >
          My CV
        </a>
      </div>
    </main>
  );
}
